<div class="top-category-carousel" id="BUYER_PAGES.CATEGORY_NAVIGATION">
  <app-page-content-wrapper class="metro-x-top-categories-navbar__component" *ngIf="showContentWrapper">
    <div
      #categoryNavBar
      appDesktopSwipe
      *ngIf="!((categoriesLoading$ && staticItemsLoading$) | async)"
      class="metro-x-top-categories-navbar"
      (scroll)="onHorizontalScroll($event)"
      (mouseleave)="onCategoryBarLeave()"
      [mmTestId]="'HOME_PAGE.HOME_HEADER_CATEGORIES'"
    >
      <div
        (mouseenter)="closeNestedCategoriesPopover()"
        data-name="left-arrow"
        class="metro-x-top-categories-navbar__arrow-container">
        <span
          [mmTestTarget]="'metro-x-top-categories-navbar-prev-button'"
          class="metro-x-top-categories-navbar__arrow"
        >
          <mm-icon name="chevron-small-left"></mm-icon>
        </span>
      </div>
      <ng-container *ngTemplateOutlet="topOffers; context: { refElement: categoryNavBar }"></ng-container>
      <ng-container *ngTemplateOutlet="topMenuPromoLink; context: { refElement: categoryNavBar }"></ng-container>
      <ng-container *ngFor="let categoryItem of buyerCategories; trackBy: trackById; let i = index">
        <a
          class="metro-x-top-categories-navbar__item"
          (mouseenter)="onCategorySelect(categoryItem?.category, categoryNavBar)"
          (mouseleave)="onCategoryLeave()"
          (click)="onRootCategoryClick(categoryItem.category); navigateTo(categoryItem.category)"
          [appStoryblokEditable]="categoryItem.storyBlokEditable"
          [ngClass]="{
                    active:
                      categoryItem?.category &&
                      selectedCategory &&
                      categoryItem?.category?.id === selectedCategory?.id &&
                      nestedCategoryPopoverRef
                  }"
          [mmTestTarget]="'root-category-link'"
          appDisableClickEvent
        >
          {{ categoryItem?.category?.name }}
        </a>
      </ng-container>
      <div
        (mouseenter)="closeNestedCategoriesPopover()"
        data-name="right-arrow"
        class="metro-x-top-categories-navbar__arrow-container">
        <span
          [mmTestTarget]="'metro-x-top-categories-navbar-next-button'"
          class="metro-x-top-categories-navbar__arrow"
        >
          <mm-icon name="chevron-small-right"></mm-icon>
        </span>
      </div>
    </div>
  </app-page-content-wrapper>
</div>

<ng-template #topOffers let-refElement="refElement">
  <a
    class="metro-x-top-categories-navbar__item top-categories-navbar__item__angebote"
    (mouseenter)="onCategorySelect(topOffersLink?.category, refElement)"
    (mouseleave)="onCategoryLeave()"
    (click)="onRootCategoryClick(topOffersLink?.category); navigateTo(topOffersLink?.category)"
    [appStoryblokEditable]="topOffersLink?.storyBlokEditable"
    [ngClass]="{
                    active:
                      topOffersLink?.category &&
                      selectedCategory &&
                      topOffersLink?.category?.id === selectedCategory?.id &&
                      nestedCategoryPopoverRef
                  }"
    [mmTestTarget]="'root-category-link'"
    appDisableClickEvent
  >
    {{ 'HOME.HOME_PAGE.PROMO_CATEGORIES.PARENT_CATEGORY_TITLE' | translate }}
  </a>
</ng-template>

<ng-template #topMenuPromoLink let-refElement="refElement">
  <a
    class="metro-x-top-categories-navbar__item"
    (mouseenter)="onCategorySelect(topMenuPromotionLink?.category, refElement)"
    (mouseleave)="onCategoryLeave()"
    (click)="onRootCategoryClick(topMenuPromotionLink?.category); navigateTo(topMenuPromotionLink?.category)"
    [appStoryblokEditable]="topMenuPromotionLink?.storyBlokEditable"
    [ngClass]="{
                      active:
                        topMenuPromotionLink?.category &&
                        selectedCategory &&
                        topMenuPromotionLink?.category?.id === selectedCategory?.id &&
                        nestedCategoryPopoverRef
                    }"
    [mmTestTarget]="'root-category-link'"
    appDisableClickEvent
  >
    {{ topMenuPromotionLink?.category?.name }}
  </a>
</ng-template>

<ng-template #nestedCategoriesRef>
  <div
    class="nested-categories"
    test-target="nested-categories"
  >
    <!-- begin nav category for promo on DESKTOP -->
    <ng-container *ngIf="selectedCategory?.id === promoCategoryId">
      <app-promo-categories
        [selectedCategory]="selectedCategory"
        (menuClosed)="closeNestedCategoriesPopover()"
      ></app-promo-categories>
    </ng-container>
    <!-- end nav category for promo on DESKTOP -->
    <!-- begin nav nested categories -->
    <ng-container *ngIf="selectedCategory?.id !== promoCategoryId">
      <!-- show all link for parent top category -->
      <header class="nested-categories__header">
        <a
          (click)="onNestedCategoryClick(selectedCategory?.name, categoryClickGALabel);navigateTo(topOffersLink?.category)"
          class="nested-categories__header__show-parent"
          [mmTestTarget]="'nested-category-link'"
        >
          {{ 'HEADER.ALL_PAGES.HEADER.CATEGORIES.SHOW_ALL' | translate }} {{ selectedCategory?.name }}
          <mm-icon name="arrow-right" class="nested-categories__arrow"></mm-icon>
        </a>
      </header>
      <div class="nested-categories__border"></div>
      <!-- nested categories -->
      <div *ngIf="isSidenavMenuVisible" class="nested-categories__bubble-wrapper">
        <app-category-bubble
          [ngStyle]="{ width: '10%' }"
          *ngFor="let nested of selectedCategory?.children; let i = index"
          [category]="nested[0]"
          [isInNavigationMenu]="true"
          (categoryClick)="navigateTo($event)"
          (closeNestedCategoriesPopover)="closeNestedCategoriesPopover()"
        ></app-category-bubble>
      </div>
      <div *ngIf="!isSidenavMenuVisible" class="nested-categories__wrapper">
        <ng-container *ngFor="let nested of selectedCategory?.children; let i = index">
          <div class="nested-categories__wrapper__children">
            <div
              fxLayout="column"
              *ngFor="let subNested of nested"
              class="nested-categories__children"
              [ngClass]="{
                'nested-categories__children__first_test': i <= NUMBER_4,
                'nested-categories__children__all': i > NUMBER_4
              }"
            >
              <app-top-categories-navbar-second-level
                [childCategory]="subNested"
                [parentCategory]="selectedCategory"
                (categoryClick)="navigateTo($event)"
                (closeNestedCategoriesPopover)="closeNestedCategoriesPopover()"
              >
              </app-top-categories-navbar-second-level>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <!-- end nav nested categories -->
  </div>
</ng-template>

<div
  class="overlay"
  (click)="closeNestedCategoriesPopover()"
  (mouseenter)="closeCategoryNavigation()"
  [ngClass]="{ 'overlay--active': isNavigationActive$ | async }"
  [ngStyle]="{ 'margin-top.px': overlayTopSpace }"
></div>
